
// getting projects overview per regions
export const GET_GEONODE_LAYERS_START = "MAP:GET_GEONODE_LAYERS_START";
export const GET_GEONODE_LAYERS_SUCCESS = "MAP:GET_GEONODE_LAYERS_SUCCESS";
export const GET_GEONODE_LAYERS_FAILURE = "MAP:GET_GEONODE_LAYERS_FAILURE";


// Add/Remove layer
export const SET_SELECTED_LAYER = "MAP:SET_SELECTED_LAYER";
export const REMOVE_SELECTED_LAYER = "MAP:REMOVE_SELECTED_LAYER";

